import Vue from 'vue'
import App from './App.vue'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueToasted from 'vue-toasted'
import vuescroll from 'vuescroll'
import VDragged from 'v-dragged'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'es6-promise/auto'
import onbiLib from '../../assets/common/js/onbiLib.js'
import camelCase from 'lodash/camelCase'
import VueRouter from 'vue-router'
import routerInfo from '../../assets/i5gam/js/router.js'
import vueSignature from 'vue-signature'
import 'vue-slider-component/theme/default.css'


Vue.use(onbiLib);
Vue.use(VDragged);
Vue.use(VueAwesomeSwiper);
Vue.use(VueAxios, axios);
Vue.use(vuescroll);
Vue.use(vueSignature);
Vue.config.productionTip = false;
Vue.prototype.$EventBus = new Vue();

axios.interceptors.response.use(function (response) {
    const ctrlAt = store.getters.getPageMaskAxiosCtrlAt;
    if(ctrlAt) store.commit('setPageMaskShowAt',false);
    return response;
}, function (error) {
    const ctrlAt = store.getters.getPageMaskAxiosCtrlAt;
    if(ctrlAt) store.commit('setPageMaskShowAt',false);
    console.log("응답 오류!!");
    console.log(error);
    return Promise.reject(error);
});


axios.interceptors.request.use(function(config) {
    const ctrlAt = store.getters.getPageMaskAxiosCtrlAt;
    if(ctrlAt)store.commit('setPageMaskShowAt',true);
    return config;
}, function(error) {
    const ctrlAt = store.getters.getPageMaskAxiosCtrlAt;
    if(ctrlAt) store.commit('setPageMaskShowAt',false);
    console.log("요청 오류!!");
    console.log(error);
    return Promise.reject(error);
});


var toast_options={
    duration:3000,
    position:'top-center',
    fullWidth:false,
    fitToScreen:true,
    iconPack:'mdi',
    theme: 'toasted-primary',
    type: 'error',
    closeOnSwipe:true,
    action : {
        class:'toasted-close',
        text:'Ⅹ',
        onClick : function(e, toastObject) {
            toastObject.goAway(0);
        }
    }
};

Vue.use(VueToasted,toast_options);

/*params 컴포넌트들이 있는 폴더,하위 폴더까지 포함할 지 여부,?*/
const commonComponent = require.context('../common/components',false,/\w+\.(vue)$/)
commonComponent.keys().forEach(function(fileName){
    const componentConfig = commonComponent(fileName);
    const componentName = camelCase(fileName.split('/').pop().replace(/\.\w+$/, ''));
    Vue.component(componentName,componentConfig.default || componentConfig);
})

const popupComponent = require.context('./components',true,/\w+\.(vue)$/);
popupComponent.keys().forEach(function(fileName){
    if(fileName.indexOf('./common/popup/') == -1){
        const componentConfig = popupComponent(fileName);
        const componentName = camelCase(fileName.split('/').pop().replace(/\.\w+$/, ''));
        Vue.component(componentName,componentConfig.default || componentConfig);
    }
});

Vue.use(VueRouter);

const router = new VueRouter({
    mode:'history',
    routes:routerInfo.I5GAM_ROUTERS
})

router.beforeEach(function(to,from,next){
    store.commit('setRouteInfo',{trget:'viewType',value:to.meta.viewType});
    store.commit('setRouteInfo',{trget:'name',value:to.name});
    window.scrollTo(0, 0);
    if(document.getElementById('content-area'))document.getElementById('content-area').scrollTop = 0;
    next();
})

window.commonPage = new Vue({
    data:{
        initParam: {},
    },
    methods: {
        callWindowPopup: function(param){
            this.initParam = param;
            window.open('/frontend/commonIndex.html', '_blank');
        },
        getInitParam: function(){
            return this.initParam;
        }
    }
});

new Vue({
    el: '#app',
    store,
    render: h => h(App),
    router,
})



